module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "fs",
    attrs: {
      "id": "page016"
    }
  }, [_c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_1"
    }
  }, [_vm._v("BRIOCHES")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_2"
    }
  }, [_vm._v("TIME REQUIRED: "), _c('span', {
    staticClass: "page016_2a"
  }, [_vm._v("1 hour")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_3"
    }
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("rioches are believed")]), _vm._v(" to have originated in Normandy. What")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_4"
    }
  }, [_vm._v("makes these brioches special is that a small ball of yeast dough is")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_5"
    }
  }, [_vm._v("Makes 30 brioches")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_6"
    }
  }, [_vm._v("set on top of a larger one like a pyramid.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_7"
    }
  }, [_vm._v("500 g plain flour")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_8"
    }
  }, [_vm._v("1.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_8a"
    }
  }, [_c('span', {
    staticClass: "page016_8a"
  }, [_vm._v(" Grease the brioche moulds well with margarine at room")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_9"
    }
  }, [_vm._v("30 g fresh yeast")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_10"
    }
  }, [_vm._v("temperature.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_11"
    }
  }, [_vm._v("2.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_11a"
    }
  }, [_c('span', {
    staticClass: "page016_11a"
  }, [_vm._v(" To make the sponge starter, sift some flour into a bowl, make a")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_12"
    }
  }, [_vm._v("6 tablespoons lukewarm")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_13"
    }
  }, [_vm._v("well and crumble the yeast into it. Mix with soya milk, sugar and")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_14"
    }
  }, [_vm._v("soya milk")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_15"
    }
  }, [_vm._v("a little more flour. Cover with a cotton cloth and rest in a warm")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_16"
    }
  }, [_vm._v("2 tsp sugar")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_17"
    }
  }, [_vm._v("place for about 15 minutes.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_18"
    }
  }, [_vm._v("150 g high-quality vegan")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_19"
    }
  }, [_vm._v("3.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_19a"
    }
  }, [_c('span', {
    staticClass: "page016_19a"
  }, [_vm._v(" Melt the margarine and leave it to cool. Mix it with the flour,")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_20"
    }
  }, [_vm._v("margarine")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_21"
    }
  }, [_vm._v("soya yoghurt and salt. Mix all the ingredients together. Knead the")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_22"
    }
  }, [_vm._v("4 tbsp soya yoghurt")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_23"
    }
  }, [_vm._v("dough with your hands until it becomes elastic. Cover again and")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_24"
    }
  }, [_vm._v("½ tsp salt")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_25"
    }
  }, [_vm._v("leave to rise for 15 minutes.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_26"
    }
  }, [_vm._v("Vegan cream, for glazing")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_27"
    }
  }, [_vm._v("4.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_27a"
    }
  }, [_c('span', {
    staticClass: "page016_27a"
  }, [_vm._v(" Knead the dough well, divide in half and roll each half into a")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_28"
    }
  }, [_vm._v("Vegan margarine, for")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_29"
    }
  }, [_vm._v("sausage. Cut both sausages into 15 pieces of uniform size. Roll each")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_30"
    }
  }, [_vm._v("greasing")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_31"
    }
  }, [_vm._v("piece into a large and a small ball. Put each of the large balls into the")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_32"
    }
  }, [_vm._v("moulds and press down with your thumb to make an indentation.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_33"
    }
  }, [_vm._v("Brush inside with a little vegan cream (you can also add a little")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_34"
    }
  }, [_vm._v("jam if you like). Gently press a small ball into the indentation.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_35"
    }
  }, [_vm._v("Glaze the brioches with the vegan cream. Rest them for 10 more")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_36"
    }
  }, [_vm._v("minutes.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_37"
    }
  }, [_vm._v("5.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_37a"
    }
  }, [_c('span', {
    staticClass: "page016_37a"
  }, [_vm._v("Preheat the oven to 220°C/425°F/gas 7. Put the moulds on a")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_38"
    }
  }, [_vm._v("baking tray and, with the oven shelf on the second position from")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_39"
    }
  }, [_vm._v("the bottom, bake for 15–20 minutes, until golden. Transfer to a")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_40"
    }
  }, [_vm._v("rack and leave to cool.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_41"
    }
  }, [_vm._v("Tip:")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_41a"
    }
  }, [_c('span', {
    staticClass: "page016_41a"
  }, [_vm._v("If you don’t have brioche moulds, you can shape the brioches")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_42"
    }
  }, [_vm._v("and place them directly on the baking sheet. They may not look")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_43"
    }
  }, [_vm._v("as nice when they’re done, but they’ll taste just as good!")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_44"
    }
  }, [_vm._v("B"), _c('span', {
    staticClass: "pagen"
  }, [_vm._v("asics")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page016_0"
    }
  }, [_vm._v("16")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5eb72717","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page_016.vue
// module id = 102
// module chunks = 0